import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RuleEngineComponent } from './crud-rules/rule-engine.component';
import { ManageRulesComponent } from './manage-rules/manage-rules.component';
import { GlobalPolicyRulesComponent } from './global-policy/global-policy-rules.component';
const routes: Routes = [
  {
    path: '',
    component: ManageRulesComponent,
  },
  {
    path: 'create',
    component: RuleEngineComponent,
  },
  {
    path: 'create/:id',
    component: RuleEngineComponent,
  },
  {
    path: 'global-policy',
    component: GlobalPolicyRulesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RuleEngineRoutingModule {}
